module.exports = __webpack_public_path__ + "img/safedig_empty_slot.a77d8349.svg";